module.exports = __webpack_public_path__ + "static/media/00_720.867baa45.jpeg";